import { Modal, Table } from "react-bootstrap";
import { getCommissionProgressBySalesIdAgentId } from "../../api/commissionProgressApi";
import { useUser } from "../../context/userContext";
import { useEffect, useState } from "react";
import handleAgentName from "../../utils/userUtils";
import { handlePriceWithRM } from "../../utils/priceUtils";

export default function SalesModal({ show, onHide, selectedSale }) {
    const { user } = useUser();
    const [selectedSaleCommissionProgress, setSelectedSaleCommissionProgress] = useState(null);

    useEffect(() => {
        const fetchCommissionProgress = async () => {
            if (selectedSale) {
                const commissionProgress = await fetchCommissionProgressBySalesIdAgentId(selectedSale.salesId, user?.userId);
                setSelectedSaleCommissionProgress(commissionProgress);
            }
        };
        fetchCommissionProgress();
    }, [show, selectedSale, user?.userId]);

    if (!show) {
        return null;
    }

    const fetchCommissionProgressBySalesIdAgentId = async (salesId) => {
        try {
            const response = await getCommissionProgressBySalesIdAgentId(salesId, user?.userId);
            if (response.status === 200) {
                return response.data;
            }
            else {
                throw new Error("Failed to fetch commission progress");
            }
        }
        catch (error) {
            console.error("Error fetching commission progress:", error);
            return null;
        }
    };

    const totalPaidCommission = (selectedSaleCommissionProgress?.firstPayment || 0)
        + (selectedSaleCommissionProgress?.secondPayment || 0);
    const agentCommission = selectedSaleCommissionProgress?.commPay || 0;
    const paidCommissionProgress = Math.round(((totalPaidCommission / agentCommission) * 100) * 100) / 100;

    const commissionPayments = [
        {
            label: "First Payment",
            amount: selectedSaleCommissionProgress?.firstPayment,
            date: selectedSaleCommissionProgress?.firstPaymentOn
        },
        {
            label: "Second Payment",
            amount: selectedSaleCommissionProgress?.secondPayment,
            date: selectedSaleCommissionProgress?.secondPaymentOn
        }
    ];


    return (
        <Modal className="salesModal-modal" size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            onHide={onHide}>
            <Modal.Header closeButton>
                {/* <Modal.Title id="contained-modal-title-vcenter">
                    Sales Details For {selectedSale?.customerName}
                </Modal.Title> */}
            </Modal.Header>
            <Modal.Body>
                <Table className="salesModal-table table borderless">
                    <tbody className="salesModal-table-body">
                        <tr>
                            <td className="text-secondary salesModal-table-small-column">Customer</td>
                            <td>{selectedSale?.customerDetails.customerName}</td>
                        </tr>
                        <tr>
                            <td className="text-secondary salesModal-table-small-column">Phone Number</td>
                            <td>{selectedSale?.customerDetails.phoneNumber}</td>
                        </tr>
                        <tr>
                            <td className="text-secondary salesModal-table-small-column">Email</td>
                            <td>{selectedSale?.customerDetails.email}</td>
                        </tr>
                        <tr>
                            <td className="text-secondary salesModal-table-small-column">Address</td>
                            <td>{selectedSale?.customerDetails.address}</td>
                        </tr>
                        <tr>
                            <td className="text-secondary salesModal-table-small-column">Product Energy</td>
                            <td>{selectedSale?.energy} kWp</td>
                        </tr>
                        <tr>
                            <td className="text-secondary salesModal-table-small-column">Agent</td>
                            <td>{handleAgentName(selectedSale?.agentDetails.firstName, selectedSale?.agentDetails.lastName, selectedSale?.agentDetails.alias)}</td>
                        </tr>
                        <tr>
                            <td className="text-secondary salesModal-table-small-column">Cobroke Agent</td>
                            <td>{selectedSale.coAgentDetails
                                ? handleAgentName(selectedSale.coAgentDetails.firstName, selectedSale.coAgentDetails.lastName, selectedSale.coAgentDetails.alias)
                                : "N/A"}</td>
                        </tr>
                        <tr>
                            <td className="text-secondary salesModal-table-small-column">Ori Price</td>
                            <td>{"RM " + selectedSale?.originalPrice}</td>
                        </tr>
                        <tr>
                            <td className="text-secondary salesModal-table-small-column">Astern Disc.</td>
                            <td>{selectedSale?.discountByAstern ? handlePriceWithRM(selectedSale.discountByAstern) : "-"}</td>
                        </tr>
                        <tr>
                            <td className="text-secondary salesModal-table-small-column">Agent Disc.</td>
                            <td>{selectedSale?.discountByAgent ? handlePriceWithRM(selectedSale.discountByAgent) : "-"}</td>
                        </tr>
                        <tr>
                            <td className="text-secondary salesModal-table-small-column">Final Price</td>
                            <td>{"RM " + selectedSale?.finalPrice}</td>
                        </tr>
                        <tr>
                            <td className="text-secondary salesModal-table-small-column">Personal Sales Commission (PSC)</td>
                            <td>
                                {selectedSaleCommissionProgress
                                    ? "RM " + (selectedSaleCommissionProgress?.commPay || 0)
                                    : <span className="text-muted">No commission data</span>
                                }
                            </td>
                        </tr>
                        <tr>
                            <td className="text-secondary salesModal-table-small-column">PSC progress</td>
                            <td>
                                {selectedSaleCommissionProgress ? (
                                    <>
                                        <p className="salesModal-p">
                                            {
                                                paidCommissionProgress
                                                    ? paidCommissionProgress + "%"
                                                    : <span className="text-muted">No progress data</span>
                                            }

                                        </p>
                                        {
                                            totalPaidCommission > 0
                                                ? <p className="text-muted" style={{ fontSize: '0.8rem' }}>{"Paid: RM" + totalPaidCommission}</p>
                                                : null
                                        }
                                        {
                                            commissionPayments.map((payment, index) => (
                                                payment.amount && payment.amount > 0
                                                    ? <ul className="salesModal-ul" key={index}>
                                                        <li className="salesModal-li">
                                                            <span className="text-muted">
                                                                {"RM" + payment.amount}
                                                            </span>
                                                            {
                                                                payment.date &&
                                                                <span className="text-muted salesModal-span">
                                                                    {"(" + new Date(payment.date).toLocaleDateString() + ")"}
                                                                </span>
                                                            }
                                                        </li>
                                                    </ul>
                                                    : null
                                            ))
                                        }
                                    </>
                                ) : (
                                    <span className="text-muted">No commission progress data</span>
                                )}

                            </td>
                        </tr>
                    </tbody>
                </Table>
            </Modal.Body>
            {/* <Modal.Footer>
                <Button onClick={onHide}>Close</Button>
            </Modal.Footer> */}
        </Modal >
    )
}